import { PensionsListDTO } from '@components/Home/Pensions/models/PensionListItem.model';
import { createSlice } from '@reduxjs/toolkit';
import { CurrentContributionsDTO, DebtDTO } from '@shared/models/ContributionsDTO.model';

interface SummaryStateElement<T> {
  data: T;
  loading: boolean;
  error: string | null;
}

interface InsuranceHistorySummaryDTO {
  freelancer: { totalFreelancingYears: number; totalFreelancingMonths: number; totalFreelancingDays: number };
  employee: { totalDays: number };
}

interface SummaryState {
  initialCallHasBeenMade: boolean;
  pensions: SummaryStateElement<PensionsListDTO>;
  contributions: SummaryStateElement<CurrentContributionsDTO>;
  debts: SummaryStateElement<DebtDTO>;
  insuranceHistorySummary: SummaryStateElement<InsuranceHistorySummaryDTO>;
}

const initialState: SummaryState = {
  initialCallHasBeenMade: false,
  pensions: { data: { amountsSummary: '', pensionInfoList: [] }, loading: true, error: null },
  contributions: {
    data: { sumTotalAmounts: '', contributions: [] },
    loading: false,
    error: null
  },
  debts: {
    data: { totalSum: '', sumSettled: '', sumUnsettled: '', settledDebtsList: [], unsettledDebtsList: [] },
    loading: false,
    error: null
  },
  insuranceHistorySummary: {
    data: {
      freelancer: { totalFreelancingYears: 0, totalFreelancingMonths: 0, totalFreelancingDays: 0 },
      employee: { totalDays: 0 }
    },
    loading: false,
    error: null
  }
};

export const summarySlice = createSlice({
  name: 'summary',
  initialState,
  reducers: {
    setInitialCallHasBeenMade: (state, action) => {
      state.initialCallHasBeenMade = action.payload;
    },
    setPensions: (state, action) => {
      state.pensions = action.payload;
    },
    setContributions: (state, action) => {
      state.contributions = action.payload;
    },
    setDebts: (state, action) => {
      state.debts = action.payload;
    },
    setInsuranceHistorySummary: (state, action) => {
      state.insuranceHistorySummary = action.payload;
    }
  }
});

export const SummaryActions = summarySlice.actions;
export const SummaryReducer = summarySlice.reducer;
